export default {
    myCenter: {
        personalInformation: 'Profile',
        pointChange: 'Credits Record',
        orderRecord: 'Payment Records',
        usageRecord: 'Usage Records',
        versionUpgradeSuccess: 'Version Upgrade Success',
        newFunctionUsageQuestion: 'New function usage questions can be contacted with product consultants',
        refresh: 'Refresh',
        source: 'Source',
        amount: 'Amount',
        type: 'Type',
        time: 'Time',
        modify: 'Edit',
        signIn: 'Check In',
        share: 'Share',
        avatar: 'Avatar',
        nickname: 'Username',

        account: 'Account',
        team: 'Team',
        company: 'Company',
        companyTip: 'Company ',
        teamTip: 'Team ',
        bindingPhone: 'Binding Phone',
        bindingWx: 'Binding Wx',
        quitTeam: 'Quit Team',
        manage: 'Manage',
        balanceTip: 'Balance',
        score: 'credits',
        recharge: 'Upgrade',
        rules: 'Rules',
        queryBalanceRemind: 'Alarm',
        benefitsTip: 'Benefits',
        exchange: 'Exchange',
        view: 'View',
        benefitsRules: 'Benefits',
        shareTip: 'App Link',
        copyLink: 'Copy Link',
        queryBalanceRemindTitle: 'Credits Alarm',
        pleaseEnterBalanceRemindThreshold: 'Please enter balance remind threshold',
        setSuccess: 'Set Success',
        enabled: 'Enabled',
        threshold: 'Threshold',
        queryBalanceRemindTip: 'Email will be sent when the balance falls below this threshold',
        modifyPersonalInformation: 'Information',
        avatarTip: 'Avatar ',
        nicknameTip: 'Nickname ',
        phoneTip: 'Phone ',
        emailTip: 'Email ',
        modifyPassword: 'Modify Password',
        forgetPassword: 'Forget Password',
        rechargeAmount: 'Recharge Amount',
        specialOffer: 'Special Offer',
        rechargeNow: 'Recharge Now',
        scanCodePay: 'Please use WeChat to scan and pay',
        billingRules: 'Billing Rules',
        detailedRules: 'Detailed Rules',
        dailySignIn: 'Daily Sign In',
        dailySignInTip: 'Daily sign-in can randomly obtain credits',
        shareBenefits: 'Share Benefits',
        shareBenefitsTip: 'Share the web exclusive link to invite new users, each new user can obtain 300 credits',
        creatorBenefits: 'Creator Benefits',
        creatorBenefitsTip: 'The 20% of the credits obtained by others calling the application will be converted into your point income.',
        activity: 'Activity 🔥',
        activityTip: 'Share your LinkAI usage experience, win credits, cash rewards, and learn more details here',
        learnMore: 'Learn More',
        phoneNumber: 'Email',
        password: 'Password',
        oldPassword: 'Old Password',
        newPassword: 'New Password',
        verificationCode: 'Verification Code',
        enterEmail: 'Enter your Email',
        pleaseEnterPhoneNumber: 'Please enter phone number',
        pleaseEnterOldPassword: 'Enter your old password',
        pleaseEnterNewPassword: 'Set your new password',
        pleaseEnterPassword: 'Enter your password',
        verificationCodeTip: 'Enter code',
        enterVerificationCode: 'Enter your code',
        benefits: 'Benefits',
        redeemIntegral: 'Redeem Integral',
        orderNo: 'Order Number',
        charge: 'Credit Recharge',
        pleaseSelectSource: 'Select source',
        pleaseSelectType: 'Select type',
        app: 'Agents',
        pleaseSelectApp: 'Select agent',
        hitKnowledgeBase: 'Hit knowledge base',
        pleaseSelect: 'Select',
        hitKnowledgeBaseTip: 'Hit knowledge base',
        notHitKnowledgeBaseTip: 'Not hit Knowledge Base',
        startTime: 'Start Time',
        endTime: 'End Time',
        query: 'Query',
        export: 'Export',
        appName: 'Agent Name',
        prompt: 'Prompt',
        answer: 'Answer',
        model: 'Model / Plugin',
        tokenLength: 'Tokens',
        consumePoints: 'Credits',
        statistics: 'Count',
        agent: 'Agent',
        user: 'User',
        useTime: 'Time',
        viewDetail: 'View Detail',
        consumeTotalScore: 'Total Credits',
        useDetail: 'Use Detail',
        typeTip: 'Type',
        timeTip: 'Time',
        modelTip: 'Model',
        tokenLengthTip: 'Tokens',
        consumePointsTip: 'Credits',
        contextTip: 'Context',
        contextTipNumber: 'Context Number',
        knowledgeTip: 'Knowledge',
        knowledgeItems: 'Knowledge Items',
        knowledgeItemsNumber: 'Knowledge Items Number',
        questionTip: 'Question',
        answerTip: 'Answer',
        hitNumberTip: 'Hit Number',
        requestTip: 'Request',
        resultTip: 'Result',
        totalTokenLength: 'Total tokens = Agent setting + Context memory + Knowledge chunks + Question + Reply',
        noData: 'No Data',
        exportUsageRecord: 'Export Usage Record',
        workFlow: 'WorkFlows',
        getVerificationCode: 'Get Code',
        modifyPasswordSuccess: 'Modify Password Success',
        bindPhoneSuccess: 'Bind Phone Success',
        imageUploadOnlySupportsJpegPngFormat: 'Image upload only supports jpeg,png format',
        imageSizeMustBeLessThan5MB: 'Image size must be less than 5MB!',
        modifySuccess: 'Modify Success',
        operationSuccess: 'Operation Success, Exchanged {count} Points',
        confirmExit: 'Are you sure to exit the {team}',
        confirmExitTip: 'After exiting, the original account content will be restored',
        exitTeamSpace: 'Exit Team Space',
        exitCompanySpace: 'Exit Company Space',
        exitSuccessful: 'Exit Successful',
        copySuccess: 'Copy Success',
        versionUpgrade: 'Upgrade',
        scoreRecharge: 'Recharge',
    }
}